import { render, staticRenderFns } from "./my-profile.vue?vue&type=template&id=17d87168&scoped=true"
import script from "./my-profile.vue?vue&type=script&lang=js"
export * from "./my-profile.vue?vue&type=script&lang=js"
import style0 from "./my-profile.vue?vue&type=style&index=0&id=17d87168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d87168",
  null
  
)

export default component.exports